import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

/**
 * Branded shell used by every /intake/* page.
 * - Black hero with red accent
 * - Centered card with form
 * - Trust badge row at the bottom
 */
export default function IntakeShell({ title, subtitle, icon: Icon, children, testid }) {
  return (
    <div className="min-h-screen bg-stone-50" data-testid={testid}>
      {/* Hero */}
      <div className="bg-black text-white">
        <div className="max-w-3xl mx-auto px-5 py-8 sm:py-12">
          <Link to="/" className="inline-flex items-center text-xs uppercase tracking-widest text-gray-400 hover:text-white mb-4">
            <ChevronLeft className="h-3 w-3 mr-1" /> Back to ACE
          </Link>
          <div className="flex items-start gap-4">
            {Icon && (
              <div className="hidden sm:flex h-14 w-14 rounded-xl bg-red-600/15 border border-red-600/30 items-center justify-center flex-shrink-0">
                <Icon className="h-7 w-7 text-red-500" />
              </div>
            )}
            <div className="flex-1">
              <p className="text-[10px] uppercase tracking-[0.3em] text-red-500 font-bold">ACE · Intake</p>
              <h1 className="text-3xl sm:text-4xl font-black tracking-tight mt-2">{title}</h1>
              <p className="text-sm sm:text-base text-gray-300 mt-3 max-w-xl">{subtitle}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Form card */}
      <div className="max-w-3xl mx-auto px-5 -mt-6 pb-12">
        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-5 sm:p-8">
          {children}
        </div>
        <p className="text-[11px] text-gray-500 text-center mt-5 px-3">
          All requests are reviewed by our team. ID verification + signed agreement required prior to delivery.
        </p>
      </div>
    </div>
  );
}

export const Field = ({ label, required, children, hint }) => (
  <div className="mb-3">
    <label className="text-[10px] font-bold uppercase tracking-wider text-gray-600">
      {label}{required && <span className="text-red-600 ml-0.5">*</span>}
    </label>
    <div className="mt-1">{children}</div>
    {hint && <p className="text-[10px] text-gray-400 mt-1">{hint}</p>}
  </div>
);

export const FieldGrid = ({ children, cols = 2 }) => (
  <div className={`grid grid-cols-1 ${cols === 2 ? 'sm:grid-cols-2' : 'sm:grid-cols-3'} gap-3`}>{children}</div>
);
